'use client'

import { createFeatureErrorPage } from '@/components/errors/feature-error'

export default createFeatureErrorPage('/')
